import React from 'react';
import { useTour } from './TourContext';

/**
 * Drop this anywhere near a page title.
 * <HelpButton tourId="crm" />
 *
 * Always shows the ? icon. Tapping it opens the feature guide for that page,
 * even if the user has already dismissed it.
 */
export default function HelpButton({ tourId }) {
  const { openGuide } = useTour();

  return (
    <button
      onClick={() => openGuide(tourId, { force: true })}
      title="Page guide"
      aria-label="Help — open page guide"
      className="btn-circle"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 26,
        height: 26,
        minWidth: 26,
        minHeight: 26,
        aspectRatio: '1 / 1',
        boxSizing: 'border-box',
        borderRadius: '50%',
        border: '2px solid #1a1a2e',
        background: 'transparent',
        color: '#1a1a2e',
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 700,
        fontSize: '0.82rem',
        cursor: 'pointer',
        flexShrink: 0,
        lineHeight: 1,
        padding: 0,
        transition: 'background 0.15s, color 0.15s',
        marginLeft: 8,
      }}
      onMouseEnter={e => {
        e.currentTarget.style.background = '#1a1a2e';
        e.currentTarget.style.color = '#fff';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = 'transparent';
        e.currentTarget.style.color = '#1a1a2e';
      }}
    >
      ?
    </button>
  );
}
